import React, {useRef} from 'react'
import {useTable, useFlexLayout, useResizeColumns, useFilters, useSortBy} from 'react-table'
import {prosMultiFilterText} from "../prodect/ProsCommonUi";
import {
    ATTR_PG_ROLE,
    ATTR_USER_ROLE,
    ROLE_ADMIN, ROLE_INSPECT, ROLE_NONE, ROLE_READER, ROLE_REPAIR
} from "../prodect/ProsConnect";
import BasicButton from "../components/BasicButton";

import {TimerTextInput} from "../components/TextInput";

//Identical to ProjectReportTable
function DefaultColumnFilter({column: { filterValue, preFilteredRows, setFilter }}) {
    //const count = preFilteredRows.length
    return <TimerTextInput
        placeholder={"Suodata..."}
        value={filterValue || ''}
        timerCallback={(val)=> {
            setFilter(val || undefined)
        }}
        size={"sm"}
    />
}

export function getRoleForTableUi(role) {
    switch (role) {
        case ROLE_ADMIN:   return "Hallinta";
        case ROLE_INSPECT: return "Laaja";
        case ROLE_REPAIR:  return "Rajoitettu";
        case ROLE_READER:  return "Katselu";
        case ROLE_NONE:    return "Ei oikeuksia";
        default:
            return "-";
    }
}

export function getRoleSortOrder(role) {
    if (!role) {
        return 5;
    }
    switch (role) {
        case ROLE_ADMIN:   return 0;
        case ROLE_INSPECT: return 1;
        case ROLE_REPAIR:  return 2;
        case ROLE_READER:  return 3;
        case ROLE_NONE:    return 4;
        default:           return 5;
    }
}

export function getItmRoleSortOrder(itm) {
    let role = itm.hasOwnProperty(ATTR_USER_ROLE) ? itm[ATTR_USER_ROLE] : itm[ATTR_PG_ROLE];
    return getRoleSortOrder(role);
}



export const PermissionsTable = ({ columns, data }) => {
    const tableContent = useRef(null);
    const tableHeader = useRef(null);
    let isSyncingHeaderScroll = false;
    let isSyncingContentScroll = false;

    const setTableScrollPosition = (e) => {
        if (e.target === tableHeader.current) {
            if (!isSyncingHeaderScroll) {
                window.requestAnimationFrame(() => {
                    isSyncingContentScroll = true;
                    tableContent.current.scrollLeft = tableHeader.current.scrollLeft;
                })
            }
            isSyncingHeaderScroll = false;
        }
        if (e.target === tableContent.current) {
            if (!isSyncingContentScroll) {
                window.requestAnimationFrame(() => {
                    isSyncingHeaderScroll = true;
                    tableHeader.current.scrollLeft = tableContent.current.scrollLeft;
                })
            }
            isSyncingContentScroll = false;
        }
    }

    const filterTypes = React.useMemo(
        () => ({
                // text filter prosMultiFilterText() is
                // - normal type of 'contains' / inclusive
                // - with "-" minus on front exclusive
                // - comma delimeted for multiple words
                text: (rows, id, filterValue) => {
                    return rows.filter(row => {
                        const rowValue = row.values[id]
                        return rowValue !== undefined
                            ? prosMultiFilterText(String(filterValue), String(rowValue))
                            : true
                    })
                },
                filterRole: (rows, id, filterValue) => {
                    return rows.filter(row => {
                        const rowValue = row.values[id]
                        if (!rowValue) {
                            return true
                        }
                        const roleId = rowValue.hasOwnProperty(ATTR_PG_ROLE) ?
                            rowValue[ATTR_PG_ROLE] : rowValue[ATTR_USER_ROLE]
                        const roleText = getRoleForTableUi(roleId)
                        return rowValue ? prosMultiFilterText(String(filterValue), roleText) : true
                    })
                },
            }
        ),
        []
    )

    const sortTypes = React.useMemo(() => ({
        roleSort: (rowA, rowB, id, desc) => {
            const rowValueA = rowA.values[id]
            const rowValueB = rowB.values[id]
            if (!rowValueA || !rowValueB) {
                return 0
            }
            return getItmRoleSortOrder(rowValueA) - getItmRoleSortOrder(rowValueB)
        },
    }), [])

    const defaultColumn = React.useMemo(() => ({
        minWidth: 50,
        width: 140,
        maxWidth: 400,
        Filter: DefaultColumnFilter,
    }), [])

    const {
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
    } = useTable(
        {
            columns,
            data,
            defaultColumn,
            filterTypes,
            sortTypes
        },
        useResizeColumns,
        useFlexLayout,
        useFilters,
        useSortBy,
    )

    return <table role={"table"}>
        <thead ref={tableHeader} onScroll={setTableScrollPosition}>
        {headerGroups.map(headerGroup => (
            <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map(column => (
                    <th {...column.getHeaderProps([{className: (column.className ? column.className : "") + (column.filterValue?.length > 0 ? " filters" : "")}])}>
                        <div className={"element-set-sm header-text" + (column.isSorted ? " sorted" : "")}
                             {...column.getSortByToggleProps()} title={"Lajittele"}
                             data-content={column.render('Header')}
                        >
                            <div className={"th-text"}>
                                {column.render('Header')}
                            </div>
                            {column.isSorted ? column.isSortedDesc ?
                                <BasicButton icon={"sort-down"} size={"xs"} title="lajittele" hilite={true} selected={true}/> :
                                <BasicButton icon={"sort-up"} size={"xs"} title="lajittele" hilite={true} selected={true}/> :
                                <BasicButton icon={"sort"} size={"xs"} title="lajittele"/>}
                        </div>
                        {column.canFilter ? column.render('Filter') : null}
                        <div className={"resizer"}
                             {...column.getResizerProps()}>
                        </div>
                    </th>
                ))}
            </tr>
        ))}
        </thead>
        <tbody {...getTableBodyProps()}
           onScroll={setTableScrollPosition}
           ref={tableContent}
       >
        {rows.map((row, i) => {
            prepareRow(row)
            return <tr {...row.getRowProps()}>
                {row.cells.map(cell => {
                    return <td {...cell.getCellProps([{
                        className: cell.column.className}
                    ])}>{cell.render('Cell')}</td>
                })}
            </tr>
        })}
        </tbody>
    </table>
}


